const inPageNav = document.querySelector('.block-in-page-nav');
const activeClass = 'block-in-page-nav--active';

if (inPageNav) {
	const labelBlock = inPageNav.querySelector('.block-in-page-nav__label');
	const mainHeader = document.querySelector('.main-header');
	const titleElement = document.createElement('span');
	titleElement.className = 'block-in-page-nav__title';

	if (mainHeader) {
		mainHeader.classList.add('main-header--has-floater');
	}

	if (!inPageNav.querySelector('.block-content') && labelBlock) {
		labelBlock.classList.add('block-in-page-nav__label--no-nav');
	}

	const navLinks = Array.from(
		inPageNav.querySelectorAll('.is-style-navigation-link')
	);

	// Determine which nav item should be marked as selected. Compare the
	// anchor's resolved (absolute) href against the current location, matching
	// the whole URL first and falling back to a hash-only match. When nothing
	// matches (e.g. the page was loaded without a hash) default to the first
	// nav item so the design's selected state is always present.
	function findSelectedNavLink() {
		if (!navLinks.length) {
			return null;
		}

		const byExactHref = navLinks.find(function (navLink) {
			const navLinkAnchor = navLink.querySelector('a');
			return navLinkAnchor && navLinkAnchor.href === location.href;
		});
		if (byExactHref) {
			return byExactHref;
		}

		if (location.hash) {
			const byHash = navLinks.find(function (navLink) {
				const navLinkAnchor = navLink.querySelector('a');
				return navLinkAnchor && navLinkAnchor.hash === location.hash;
			});
			if (byHash) {
				return byHash;
			}
		}

		return navLinks[0];
	}

	// Mark the given nav item as selected and mirror its label into the
	// collapsed header title (the "| For Practitioners" text next to the label).
	function setSelectedNavItem(selectedNavItem) {
		navLinks.forEach(function (navLink) {
			navLink.classList.toggle(
				'block-in-page-nav__selected',
				navLink === selectedNavItem
			);
		});

		if (selectedNavItem && labelBlock) {
			titleElement.innerHTML = selectedNavItem.innerHTML;
			if (titleElement.parentNode !== labelBlock) {
				labelBlock.append(titleElement);
			}
		}
	}

	// Resolve the selected item from the current URL/hash.
	function updateSelectedNavItem() {
		setSelectedNavItem(findSelectedNavLink());
	}

	updateSelectedNavItem();

	// Keep the selected item in sync as the active section/hash changes.
	window.addEventListener('hashchange', updateSelectedNavItem);

	// Clicking a nav item selects it (updates the title + highlight) and
	// collapses the dropdown, regardless of whether the hash actually changes.
	navLinks.forEach(function (navLink) {
		navLink.addEventListener('click', function () {
			setSelectedNavItem(navLink);
			inPageNav.classList.remove(activeClass);
		});
	});

	if (labelBlock) {
		labelBlock.addEventListener('click', function () {
			if (inPageNav.classList.contains(activeClass)) {
				inPageNav.classList.remove(activeClass);
			} else {
				inPageNav.classList.add(activeClass);

				const buttons = inPageNav.querySelector(
					'.block-in-page-nav__buttons'
				);
				if (buttons) {
					buttons
						.querySelectorAll('.wp-block-button--small')
						.forEach(function (button) {
							button.classList.remove('wp-block-button--small');
						});
				}
			}
		});
	}
}
